import saveData from './saveData';
import WriteToLog from "./WriteToLog";   

/**
 * Save Plan for the patient who is not yet admitted (No CSN) to a temporary location in EHR
 * @param {*} patID - Patient Internal ID
 * @param {*} csn - Patient Encounter 
 * @param {*} planehrID 
 * @param {*} ehrValue 
 * @param {*} userID 
 * @param {*} plandateehrID 
 * @param {*} createdate 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @param {*} tempPlanId 
 * @returns success if Plan saved to temporary location in EHR
 */
async function savePlanFromTempData(patID, csn, planehrID, ehrValue, userID, plandateehrID, createdate, fhir_server, access_token, tempPlanId) {
    let saveResponse = "";

    // If tempPlan older than 7 days, do no save to Encounter EHR but clear tempPlan data. Else, save to Encounter EHR and clear tempPlan data
    var json = JSON.parse(ehrValue);
    var tempPlanDate = new Date(json.CREATE_DATETIME);
    tempPlanDate.setDate(tempPlanDate.getDate() + 7);
    var currentDate = new Date();

    if (tempPlanDate > currentDate) { 
        //WriteToLog("Save TempPlan to EncounterPlan EHR");
        /* Step 1: Save tempPlan value to EHR Plan EHR */
        let ehrResponse = await saveData(patID, csn, planehrID, ehrValue, userID, fhir_server, access_token);
        //WriteToLog("savePlanFromTempData - After saveData Plan response: " + ehrResponse); 
        if (ehrResponse === "success") {
            WriteToLog('savePlanFromTempData - Plan saved successfully for patient: ' + patID);       
            /* Step 2: Save Plan Complete Date to EHR Patient EHR */
            let planDateResponse = await saveData(patID, csn, plandateehrID, createdate, userID, fhir_server, access_token);
            if (planDateResponse === "success") {
                WriteToLog('savePlanFromTempData - PlanDate saved successfully for patient: ' + patID); 
        
                /* Step 3: Clear tempPlanId and planDateId Patient EHR values */
                let tempValue = "";
                let clearDate = "";
                let tempehrResponse = await saveData(patID, '99999', tempPlanId, tempValue, userID, fhir_server, access_token);
                let tempplanDateResponse = await saveData(patID, '99999', plandateehrID, clearDate, userID, fhir_server, access_token);
                if (tempehrResponse === "success" && tempplanDateResponse === "success") {
                    saveResponse = "success";
                }
                return saveResponse;
            } else {
                WriteToLog("savePlanFromTempData - Plan Complete Date not saved to EHR: " + planDateResponse);
                return saveResponse;
            }
        } else {
            WriteToLog("savePlanFromTempData - Plan not saved to EHR: " + ehrResponse);
            return saveResponse;
        }
    } else {
        WriteToLog('DO NOT SAVE templPlan values to EncounterPlan EHR');
        /* Clear tempPlanId and planDateId Patient EHR values */
        let tempValue = "";
        let clearDate = "";
        let tempehrResponse = await saveData(patID, '99999', tempPlanId, tempValue, userID, fhir_server, access_token);
        let tempplanDateResponse = await saveData(patID, '99999', plandateehrID, clearDate, userID, fhir_server, access_token);
        if (tempehrResponse === "success" && tempplanDateResponse === "success") {
            saveResponse = "success";
        }
        return saveResponse;
    }
}

export default savePlanFromTempData;
